import { getContentfulFAQ } from 'api/contentful/getContentfulFAQ'
import { PricingPage } from 'components/pricingPage/PricingPage'
import { GetStaticProps } from 'next'
import { getContentfulImages } from 'utils/contentful/getPageImages'
import { getEstatePlanningPrice } from 'utils/getInitialEstatePlanningPrice'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export default PricingPage

export const getStaticProps: GetStaticProps = async (ctx) => {
  const faq = await getContentfulFAQ('trust_pricing')

  const estatePlanningPrice = await getEstatePlanningPrice()

  return {
    props: {
      ...(await getContentfulImages()),
      ...(await getIntlProps(ctx, ['trust_lp', 'pricing_plan'])),
      estatePlanningPrice,
      faq,
    },
  }
}
